import { createMuiTheme,  } from '@material-ui/core/styles';

const primary = "#0155aa";

const theme = createMuiTheme({
    palette: {
      primary: {
        main: primary,
      }
    },
  });

export default theme;